"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _ossUpload = require("@/utils/ossUpload");
var _appSetting = require("@/api/appSetting");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  data: function data() {
    return {
      AndroidUrl: '',
      fileList: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    (0, _appSetting.getManifest)({
      type: 'startImage'
    }).then(function (res) {
      if (res.data) {
        var obj = JSON.parse(res.data);
        _this.AndroidUrl = obj.AndroidUrl;
        _this.fileList = obj.fileList;
      }
    });
  },
  methods: {
    save: function save() {
      var _this2 = this;
      this.$confirm('确认是否要保存？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _appSetting.saveManifest)({
          startImage: JSON.stringify({
            AndroidUrl: _this2.AndroidUrl,
            fileList: _this2.fileList
          }, null, 2)
        }).then(function (res) {
          if (res.data) {
            _this2.$notify.success({
              title: '温馨提示',
              message: '操作成功！'
            });
          }
        });
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    jump: function jump() {
      window.location = 'http://ugcore.oss-cn-hangzhou.aliyuncs.com/share/CustomStoryboard.zip';
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(file, fileName, text) {
        var pictureUrl;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _ossUpload.uploadOSS)(file.file, 'builds', fileName);
            case 1:
              pictureUrl = _context.v;
              if (!(text === 'hm')) {
                _context.n = 2;
                break;
              }
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file.file, 'hmBuilds', 'start_window_bg.jpg');
            case 2:
              if (pictureUrl) {
                this.AndroidUrl = pictureUrl + '?pic=' + Math.random();
              }
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function handleFileUpload(_x, _x2, _x3) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    handleFileUploadIos: function () {
      var _handleFileUploadIos = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(file, fileName) {
        var pictureUrl;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return (0, _ossUpload.uploadOSS)(file.file, 'builds', fileName);
            case 1:
              pictureUrl = _context2.v;
              console.log(pictureUrl);
              this.fileList = [{
                name: file.file.name,
                url: pictureUrl
              }];
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handleFileUploadIos(_x4, _x5) {
        return _handleFileUploadIos.apply(this, arguments);
      }
      return handleFileUploadIos;
    }(),
    handleRemove: function handleRemove() {
      this.fileList = [];
    }
  }
};